import { ErrorHandler, Injectable, isDevMode } from '@angular/core';
import { NotificationService } from './notification.service';
import { environment } from '@app/../environments/environment';

@Injectable()
export class GlobalErrorHandler implements ErrorHandler {
  constructor(private notificationService: NotificationService) {}

  handleError(error: unknown): void {
    const message = this.extractMessage(error);

    if (isDevMode()) {
      console.error('[GlobalErrorHandler]', error);
    }

    // Send to Sentry in production
    if (environment.production && environment.sentryDsn) {
      import('@sentry/angular').then(Sentry => {
        Sentry.captureException(error);
      }).catch(() => { /* Sentry not available */ });
    }

    this.notificationService.showError(message);
  }

  private extractMessage(error: unknown): string {
    if (error instanceof Error) {
      if (error.message.includes('ChunkLoadError') || error.message.includes('Loading chunk')) {
        return 'Une mise a jour est disponible. Veuillez rafraichir la page.';
      }
      if (error.message.includes('NetworkError') || error.message.includes('Failed to fetch')) {
        return 'Erreur de connexion reseau. Verifiez votre connexion internet.';
      }
      return isDevMode() ? error.message : 'Une erreur inattendue est survenue.';
    }
    return 'Une erreur inattendue est survenue.';
  }
}
